<template>
    <div class="my-taxi-info">
        <RentalInfo></RentalInfo>
    </div>
</template>
<script>
    import RentalInfo from "../components/RentalInfo";
    export default {
        components: {RentalInfo},
    }
</script>